import { useSyncExternalStore } from 'react'
import { Observer } from 'shared/observer'

const observer = new Observer(false)

const useInviteModal = () =>
	useSyncExternalStore(observer.subscribe, () => observer.value)

const openInvite = () => {
	observer.value = true
}
const closeInvite = () => {
	observer.value = false
}

export { closeInvite, openInvite, useInviteModal }
